__turbopack_context__.v({
  "card": "APX_Ga_card",
});
